(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_announcement"] && !Shopify.designMode) return;
  try {
    if (!window.__klaviyoFormClick) {
    window.__klaviyoFormClick = true;
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-klaviyo-form]');
      if (!btn) return;
      e.preventDefault();
      window._klOnsite = window._klOnsite || [];
      window._klOnsite.push(['openForm', btn.getAttribute('data-klaviyo-form')]);
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["buy-once-button"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.__pgOnce) return;
    window.__pgOnce = true;

    var ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

    function log() {
      if (window.console && console.info) {
        console.info.apply(console, ['[Buy once]'].concat([].slice.call(arguments)));
      }
    }

    function setText(el, text) {
      if (el && el.textContent !== text) el.textContent = text;
    }

    function money(cents, currency) {
      var amount = cents / 100;
      var whole = Math.round(amount * 100) % 100 === 0;
      try {
        return new Intl.NumberFormat(document.documentElement.lang || 'en-US', {
          style: 'currency', currency: currency || 'USD',
          minimumFractionDigits: whole ? 0 : 2, maximumFractionDigits: 2
        }).format(amount);
      } catch (e) {
        return '$' + (whole ? amount.toFixed(0) : amount.toFixed(2));
      }
    }

    function variantsOf(box) {
      try { return JSON.parse(box.getAttribute('data-variants')) || []; } catch (e) { return []; }
    }

    // The pack picked in the Pizza Night picker (same section)
    function selectedPack(box) {
      var section = box.closest('.shopify-section') || document;
      var input = section.querySelector('.pg-picker .pg-packs input:checked') || document.querySelector('.pg-picker .pg-packs input:checked');
      return input ? input.value : null;
    }

    function currentVariant(box) {
      var variants = variantsOf(box);
      var pack = selectedPack(box);
      return variants.find(function (v) { return v.pack === pack; }) || (pack === null ? variants[0] : null);
    }

    function update(box) {
      var button = box.querySelector('[data-pg-once-button]');
      if (button.classList.contains('is-loading')) return;
      var label = box.querySelector('[data-pg-once-label]');
      var v = currentVariant(box);
      if (!v || !v.available) {
        button.disabled = true;
        setText(label, box.getAttribute('data-text-soldout'));
        return;
      }
      button.disabled = false;
      setText(label, (box.getAttribute('data-text') || '').split('[price]').join(money(v.price, box.getAttribute('data-currency'))));
    }

    function showError(box, message) {
      var el = box.querySelector('[data-pg-once-error]');
      setText(el, message || '');
      el.hidden = !message;
    }

    function setLoading(box, loading) {
      var button = box.querySelector('[data-pg-once-button]');
      button.classList.toggle('is-loading', loading);
      button.setAttribute('aria-busy', loading ? 'true' : 'false');
      button.disabled = loading;
      if (loading) setText(box.querySelector('[data-pg-once-label]'), box.getAttribute('data-text-loading'));
      else update(box);
    }

    // Tell Horizon a line was added: refreshes the cart drawer / count and opens the drawer
    function announce(button, cart, sections) {
      var event = new Event('shopify:cart:lines-update', { bubbles: true });
      event.action = 'add';
      event.context = 'product';
      event.lines = [];
      event.promise = Promise.resolve({
        cart: { id: cart.token, totalQuantity: cart.item_count },
        detail: { source: 'pg-buy-once', sourceId: 'pg-buy-once', items: cart.items, itemCount: cart.item_count, sections: sections }
      });
      button.dispatchEvent(event);
    }

    document.addEventListener('click', function (e) {
      var button = e.target instanceof Element ? e.target.closest('[data-pg-once-button]') : null;
      if (!button || button.disabled) return;
      // This button must never submit the theme's subscription form
      e.preventDefault();
      e.stopPropagation();
      var box = button.closest('[data-pg-once]');
      var v = currentVariant(box);
      if (!v) return;

      showError(box, '');
      setLoading(box, true);

      // Ask Shopify for fresh cart HTML for every cart on the page (drawer / cart page)
      var sectionIds = Array.prototype.map
        .call(document.querySelectorAll('cart-items-component[data-section-id]'), function (el) { return el.dataset.sectionId; })
        .filter(Boolean);

      log('adding one-time', v.pack, 'variant', v.id);
      // No selling_plan = one-time purchase. Only the pack: no grill / kit, no free pizza, no code.
      var item = { id: v.id, quantity: 1, selling_plan: null };
      // A visible line on the cart item, so it's clearly not a subscription
      var onceLabel = box.getAttribute('data-once-label');
      var onceValue = box.getAttribute('data-once-value');
      if (onceLabel && onceValue) {
        item.properties = {};
        item.properties[onceLabel] = onceValue;
      }
      var body = { items: [item] };
      if (sectionIds.length) body.sections = sectionIds.join(',');

      fetch(ROOT + 'cart/add.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(body)
      })
        .then(function (res) {
          return res.json().then(function (data) {
            if (!res.ok || data.status) {
              throw new Error(data.description || data.message || box.getAttribute('data-text-error'));
            }
            return data;
          });
        })
        .then(function (added) {
          // Safety net: if anything attached a subscription plan to this line, remove it
          var line = (added.items || [])[0];
          if (line && line.selling_plan_allocation) {
            log('a subscription plan was attached to the one-time pack, removing it', line.selling_plan_allocation.selling_plan && line.selling_plan_allocation.selling_plan.name);
            return fetch(ROOT + 'cart/change.js', {
              method: 'POST',
              credentials: 'same-origin',
              headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
              body: JSON.stringify({ id: line.key, quantity: line.quantity, selling_plan: null, sections: body.sections })
            }).then(function (res) { return res.json(); }).then(function (cart) {
              announce(button, cart, cart.sections || added.sections);
            });
          }
          log('added as one-time (no subscription)');
          return fetch(ROOT + 'cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
            .then(function (res) { return res.json(); })
            .then(function (cart) { announce(button, cart, added.sections); });
        })
        .catch(function (error) {
          log('add failed:', error);
          showError(box, (error && error.message) || box.getAttribute('data-text-error'));
        })
        .then(function () { setLoading(box, false); });
    });

    function updateAll() {
      document.querySelectorAll('[data-pg-once]').forEach(update);
    }

    var queued = false;
    function schedule() {
      if (queued) return;
      queued = true;
      requestAnimationFrame(function () {
        queued = false;
        updateAll();
      });
    }

    function start() {
      updateAll();
      document.addEventListener('change', schedule);
      document.addEventListener('click', schedule);
      new MutationObserver(schedule).observe(document.body, { childList: true, subtree: true });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', start);
    } else {
      start();
    }
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["ca-shipping-notice"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.__pgCaNotice) return;
    window.__pgCaNotice = true;

    // Open the Klaviyo popup; if Klaviyo isn't on the page, go to the fallback link
    document.addEventListener('click', function (e) {
      var btn = e.target instanceof Element ? e.target.closest('[data-pg-ca-klaviyo]') : null;
      if (!btn) return;
      e.preventDefault();
      var formId = btn.getAttribute('data-pg-ca-klaviyo');
      var fallback = btn.getAttribute('data-fallback');
      // Klaviyo's script defines window.klaviyo once it has loaded
      var klaviyoReady = !!window.klaviyo;
      if (!klaviyoReady && fallback) {
        window.location.href = fallback;
        return;
      }
      window._klOnsite = window._klOnsite || [];
      window._klOnsite.push(['openForm', formId]);
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["claim-button"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.__pgClaim) return;
    window.__pgClaim = true;

    function setText(el, text) {
      if (el && el.textContent !== text) el.textContent = text;
    }

    function money(cents, currency) {
      if (!cents && cents !== 0) return '';
      var amount = cents / 100;
      var whole = Math.round(amount * 100) % 100 === 0;
      try {
        return new Intl.NumberFormat(document.documentElement.lang || 'en-US', {
          style: 'currency', currency: currency || 'USD',
          minimumFractionDigits: whole ? 0 : 2, maximumFractionDigits: 2
        }).format(amount);
      } catch (e) {
        return '$' + (whole ? amount.toFixed(0) : amount.toFixed(2));
      }
    }

    function sectionOf(el) {
      return el.closest('.shopify-section') || document;
    }

    function log() {
      if (window.console && console.info) {
        console.info.apply(console, ['[Claim button]'].concat([].slice.call(arguments)));
      }
    }

    // The Buy buttons form: by its usual ID, else any add to cart form in this section, else on the page
    function themeForm(claim) {
      var form = document.getElementById(claim.getAttribute('data-form-id'));
      if (form) return form;
      var section = sectionOf(claim);
      var selector = 'form[data-type="add-to-cart-form"], form[action*="/cart/add"]';
      form = (section !== document && section.querySelector(selector)) || document.querySelector('product-form-component form') || document.querySelector(selector);
      return form || null;
    }

    function themeButton(form) {
      return form && form.querySelector('button[name="add"], button[type="submit"]');
    }

    // Today's total = the price shown on the selected plan card of the Pizza Night picker
    function readChoice(claim) {
      var section = sectionOf(claim);
      var picker = section.querySelector('.pg-picker') || document.querySelector('.pg-picker');
      if (!picker) return { oven: false, total: '', pizzaPrice: null };
      var oven = !!picker.querySelector('[data-pg-oven-input]:checked');
      var totalEl = oven
        ? picker.querySelector('[data-pg-oven-price]')
        : (function () {
            var plan = picker.querySelector('.pg-plan--simple input:checked');
            return plan && plan.closest('.pg-plan').querySelector('.pg-plan__price strong');
          })();
      return {
        oven: oven,
        total: totalEl ? totalEl.textContent.trim() : '',
        pizzaPrice: Number(picker.getAttribute('data-pg-pizza-price')) || null
      };
    }

    function update(claim) {
      var button = claim.querySelector('[data-pg-claim-button]');
      var label = claim.querySelector('[data-pg-claim-label]');
      if (button.classList.contains('is-loading')) return;

      // Sold out / unavailable: copy the theme button's state and text
      var original = themeButton(themeForm(claim));
      if (original && original.disabled) {
        button.disabled = true;
        setText(label, original.textContent.replace(/\s+/g, ' ').trim());
        return;
      }
      button.disabled = false;

      var choice = readChoice(claim);
      var template = claim.getAttribute(choice.oven ? 'data-text-oven' : 'data-text-pizza') || '';
      setText(label, template.split('[total]').join(choice.total));

      var renew = claim.querySelector('[data-pg-claim-renew]');
      if (renew) {
        var section = sectionOf(claim);
        var deliver = section.querySelector('.pg-deliver__input:checked') || document.querySelector('.pg-deliver__input:checked');
        var title = deliver && deliver.closest('.pg-deliver__card').querySelector('.pg-deliver__title');
        var frequency = ((title && title.textContent.trim()) || claim.getAttribute('data-default-frequency') || '').toLowerCase();
        var text = (claim.getAttribute('data-renew') || '')
          .split('[price]').join(choice.pizzaPrice ? money(choice.pizzaPrice, claim.getAttribute('data-currency')) : '')
          .split('[frequency]').join(frequency);
        setText(renew, text);
      }
    }

    function showError(claim, message) {
      var el = claim.querySelector('[data-pg-claim-error]');
      setText(el, message || '');
      el.hidden = !message;
    }

    function setLoading(claim, loading) {
      var button = claim.querySelector('[data-pg-claim-button]');
      button.classList.toggle('is-loading', loading);
      button.setAttribute('aria-busy', loading ? 'true' : 'false');
      if (loading) {
        button.disabled = true;
        var text = claim.getAttribute('data-text-loading');
        if (text) setText(claim.querySelector('[data-pg-claim-label]'), text);
      } else {
        button.disabled = false;
        update(claim);
      }
    }

    var pending = null; // the claim button waiting for the cart
    var ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

    // Apply the plan's discount code(s) to the cart, e.g. "PIZZANIGHT1,OVEN100".
    // Several codes are separated by commas. Shopify uses them at checkout.
    function applyDiscount(claim) {
      var code = (claim.__pgCode || '')
        .split(',')
        .map(function (c) { return c.trim(); })
        .filter(Boolean)
        .join(',');
      if (!code) return;
      fetch(ROOT + 'cart/update.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ discount: code })
      })
        .then(function (res) {
          if (!res.ok) throw new Error('cart/update ' + res.status);
          log('discount code applied:', code);
        })
        .catch(function () {
          // Older way: the /discount/ link saves the code(s) for checkout, one at a time
          return code.split(',').reduce(function (chain, single) {
            return chain.then(function () {
              return fetch(ROOT + 'discount/' + encodeURIComponent(single) + '?redirect=' + encodeURIComponent(ROOT + 'cart.js'), {
                credentials: 'same-origin'
              });
            });
          }, Promise.resolve()).then(function () { log('discount code(s) saved for checkout:', code); });
        })
        .catch(function (error) { log('could not apply discount code', code, error); });
    }

    function finish(errorMessage, skipDiscount) {
      if (!pending) return;
      var claim = pending;
      pending = null;
      clearTimeout(claim.__pgTimer);
      setLoading(claim, false);
      if (errorMessage) showError(claim, errorMessage);
      else if (!skipDiscount) applyDiscount(claim);
    }

    document.addEventListener('click', function (e) {
      var button = e.target instanceof Element ? e.target.closest('[data-pg-claim-button]') : null;
      if (!button || button.disabled) return;
      var claim = button.closest('[data-pg-claim]');
      var form = themeForm(claim);
      if (!form) {
        log('No Buy buttons form found on this page. Add the theme\'s "Buy buttons" block to this product section (it can stay hidden).');
        showError(claim, claim.getAttribute('data-text-error'));
        return;
      }
      log('submitting', form.getAttribute('id') || form);
      showError(claim, '');
      // Oven plan → oven code (PIZZANIGHT1); Pizza subscription → pizza code (PIZZABOX1)
      claim.__pgCode = readChoice(claim).oven
        ? claim.getAttribute('data-discount-code')
        : claim.getAttribute('data-discount-code-pizza');
      pending = claim;
      setLoading(claim, true);
      claim.__pgTimer = setTimeout(function () { finish(); }, 8000);

      var original = themeButton(form);
      if (form.requestSubmit) {
        form.requestSubmit(original && original.form === form ? original : undefined);
      } else if (original) {
        original.click();
      } else {
        form.submit();
      }
    });

    // Horizon tells us when the add finished (or failed)
    document.addEventListener('shopify:cart:lines-update', function (e) {
      if (!pending || !e.promise || typeof e.promise.then !== 'function') return;
      e.promise.then(
        function () { finish(); },
        function (error) {
          if (error && error.name === 'AbortError') return finish();
          log('add to cart failed:', error);
          finish((error && error.message) || (pending && pending.getAttribute('data-text-error')));
        }
      );
    });
    document.addEventListener('shopify:cart:error', function (e) {
      if (!pending) return;
      var message = e.error || (e.detail && (e.detail.description || e.detail.error)) || '';
      log('Shopify said:', message || e);
      finish(message || (pending && pending.getAttribute('data-text-error')));
    });
    // The Pizza Night picker shows its own errors (e.g. sold-out colour): stop the spinner
    document.addEventListener('pg:addon-error', function () { finish('', true); });

    function updateAll() {
      document.querySelectorAll('[data-pg-claim]').forEach(update);
    }

    var queued = false;
    function schedule() {
      if (queued) return;
      queued = true;
      requestAnimationFrame(function () {
        queued = false;
        updateAll();
      });
    }

    function start() {
      updateAll();
      document.addEventListener('change', schedule);
      document.addEventListener('click', schedule);
      new MutationObserver(schedule).observe(document.body, {
        childList: true, subtree: true, characterData: true, attributes: true, attributeFilter: ['disabled', 'hidden']
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', start);
    } else {
      start();
    }
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["collection-description"] && !Shopify.designMode) return;
  try {
    class ReadMoreText extends HTMLElement {
    connectedCallback() {
      this.text = this.querySelector('.text-block');
      this.toggle = this.querySelector('.read-more__toggle');
      if (!this.text) return;

      this.check = this.check.bind(this);
      this.check();

      if ('ResizeObserver' in window) {
        this.observer = new ResizeObserver(this.check);
        this.observer.observe(this.text);
      }

      if (document.fonts && document.fonts.ready) {
        document.fonts.ready.then(this.check);
      }
    }

    disconnectedCallback() {
      if (this.observer) this.observer.disconnect();
    }

    check() {
      if (!this.text || (this.toggle && this.toggle.checked)) return;
      const overflowing = this.text.scrollHeight > this.text.clientHeight + 1;
      this.toggleAttribute('data-overflowing', overflowing);
    }
  }

  if (!customElements.get('read-more-text')) {
    customElements.define('read-more-text', ReadMoreText);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["deliver-every"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.__pgDeliver) return;
    window.__pgDeliver = true;

    // The plan the customer picked, kept in memory so a section re-draw can't undo it
    var chosen = {};

    function keyOf(root) {
      return root.getAttribute('data-block-id') || root.getAttribute('data-form-id');
    }

    function planMap(root) {
      try { return JSON.parse(root.getAttribute('data-plan-map')) || {}; } catch (e) { return {}; }
    }

    function formFor(root) {
      return document.getElementById(root.getAttribute('data-form-id'));
    }

    function log() {
      if (window.console && console.info) {
        console.info.apply(console, ['[Deliver every]'].concat([].slice.call(arguments)));
      }
    }

    // Every selling_plan field that the Add to cart form will send
    function planFields(form) {
      var fields = Array.prototype.slice.call(form.querySelectorAll('input[name="selling_plan"]'));
      if (form.getAttribute('id')) {
        document.querySelectorAll('input[name="selling_plan"][form="' + form.getAttribute('id') + '"]').forEach(function (f) {
          if (fields.indexOf(f) === -1) fields.push(f);
        });
      }
      if (!fields.length) {
        var created = document.createElement('input');
        created.type = 'hidden';
        created.name = 'selling_plan';
        form.appendChild(created);
        fields.push(created);
      }
      return fields;
    }

    // The card that should be selected: the customer's pick first, then the checked one, then the first
    function currentInput(root) {
      var wanted = chosen[keyOf(root)];
      var input = wanted ? root.querySelector('.pg-deliver__input[value="' + wanted + '"]') : null;
      return input || root.querySelector('.pg-deliver__input:checked') || root.querySelector('.pg-deliver__input');
    }

    // Check the card both live and as an attribute, so a theme re-draw (morph) keeps it
    function markChecked(root, input) {
      root.querySelectorAll('.pg-deliver__input').forEach(function (i) {
        var on = i === input;
        if (i.checked !== on) i.checked = on;
        if (on && !i.hasAttribute('checked')) i.setAttribute('checked', '');
        if (!on && i.hasAttribute('checked')) i.removeAttribute('checked');
      });
    }

    // Write the chosen card into the form's selling_plan field(s)
    function apply(root, value) {
      var input = currentInput(root);
      if (!input) return null;
      markChecked(root, input);
      var planId = value || input.value;
      var form = formFor(root);
      if (!form) return planId;
      planFields(form).forEach(function (field) {
        if (field.value !== planId) field.value = planId;
        if (field.getAttribute('value') !== planId) field.setAttribute('value', planId);
      });
      return planId;
    }

    // The plan to send for a variant: the chosen card, or the variant's first plan if
    // the chosen one isn't offered for it
    function planForVariant(root, variantId) {
      var input = currentInput(root);
      if (!input) return null;
      var allowed = planMap(root)[String(variantId)];
      if (allowed && allowed.length && allowed.indexOf(Number(input.value)) === -1) return String(allowed[0]);
      return input.value;
    }

    function rootForVariant(variantId) {
      return Array.prototype.find.call(document.querySelectorAll('[data-pg-deliver]'), function (root) {
        return Object.prototype.hasOwnProperty.call(planMap(root), String(variantId));
      });
    }

    function planFor(variantId) {
      var root = rootForVariant(variantId);
      return root ? planForVariant(root, variantId) : null;
    }

    // Set the plan inside the add to cart request body (FormData, URL-encoded or JSON)
    function fixBody(body) {
      if ((typeof FormData !== 'undefined' && body instanceof FormData) ||
          (typeof URLSearchParams !== 'undefined' && body instanceof URLSearchParams)) {
        if (!body.has('id')) return body;
        var planId = planFor(body.get('id'));
        if (planId) {
          body.set('selling_plan', planId);
          log('adding variant', body.get('id'), 'with selling plan', planId);
        }
        return body;
      }
      if (typeof body === 'string') {
        var data;
        try { data = JSON.parse(body); } catch (e) { return body; }
        var items = Array.isArray(data.items) ? data.items : (data && data.id ? [data] : []);
        var changed = false;
        items.forEach(function (item) {
          var planId = planFor(item.id);
          if (planId) {
            item.selling_plan = Number(planId);
            changed = true;
            log('adding variant', item.id, 'with selling plan', planId, '(JSON)');
          }
        });
        return changed ? JSON.stringify(data) : body;
      }
      return body;
    }

    var originalFetch = window.fetch;
    if (originalFetch && !originalFetch.__pgDeliver) {
      var wrappedFetch = function (resource, options) {
        try {
          var url = typeof resource === 'string' ? resource : (resource && resource.url) || '';
          if (url.indexOf('/cart/add') !== -1 && options && options.body) {
            options.body = fixBody(options.body);
          }
        } catch (err) {}
        return originalFetch.apply(this, arguments);
      };
      wrappedFetch.__pgDeliver = true;
      window.fetch = wrappedFetch;
    }

    // Number the heading after the Pizza Night picker's visible steps (3. or 4.)
    function number(root) {
      if (root.getAttribute('data-auto-number') !== 'true') return;
      var el = root.querySelector('[data-pg-deliver-number]');
      var section = root.closest('.shopify-section') || document;
      var picker = section.querySelector('.pg-picker');
      if (!el || !picker) return;
      var count = 0;
      picker.querySelectorAll('.pg-step').forEach(function (step) {
        if (step.offsetParent !== null) count++;
      });
      if (!count) return;
      var text = String(count + 1);
      if (el.textContent !== text) el.textContent = text;
    }

    function syncAll() {
      document.querySelectorAll('[data-pg-deliver]').forEach(function (root) {
        apply(root);
        number(root);
      });
    }

    // Remember the customer's pick
    document.addEventListener('change', function (e) {
      var input = e.target;
      if (!(input instanceof HTMLInputElement) || !input.classList.contains('pg-deliver__input')) return;
      var root = input.closest('[data-pg-deliver]');
      if (!root) return;
      chosen[keyOf(root)] = input.value;
      log('customer chose plan', input.value, input.getAttribute('data-plan-name'));
      apply(root);
    });

    // Before Add to cart: make sure the plan is valid for the chosen variant
    window.addEventListener(
      'submit',
      function (e) {
        var form = e.target;
        if (!(form instanceof HTMLFormElement)) return;
        var formId = form.getAttribute('id');
        if (!formId) return;
        var root = document.querySelector('[data-pg-deliver][data-form-id="' + formId + '"]');
        if (!root) return;
        var planId = apply(root);
        var idInput = form.querySelector('[name="id"]');
        var allowed = idInput ? planMap(root)[idInput.value] : null;
        if (planId && allowed && allowed.length && allowed.indexOf(Number(planId)) === -1) {
          apply(root, String(allowed[0]));
        }
      },
      true
    );

    var queued = false;
    function schedule() {
      if (queued) return;
      queued = true;
      requestAnimationFrame(function () {
        queued = false;
        syncAll();
      });
    }

    function start() {
      syncAll();
      new MutationObserver(schedule).observe(document.body, {
        childList: true, subtree: true, attributes: true, attributeFilter: ['hidden']
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', start);
    } else {
      start();
    }
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["delivery-notice"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-klaviyo-form]');
    if (!btn) return;
    e.preventDefault();
    window._klOnsite = window._klOnsite || [];
    window._klOnsite.push(['openForm', btn.getAttribute('data-klaviyo-form')]);
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["first-box-summary"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.__pgSummary) return;
    window.__pgSummary = true;

    function setText(el, text) {
      if (el && el.textContent !== text) el.textContent = text;
    }
    function setHidden(el, hidden) {
      if (el && el.hidden !== hidden) el.hidden = hidden;
    }

    function money(cents, currency) {
      if (cents == null || isNaN(cents)) return '';
      var amount = cents / 100;
      var whole = Math.round(amount * 100) % 100 === 0;
      try {
        return new Intl.NumberFormat(document.documentElement.lang || 'en-US', {
          style: 'currency', currency: currency || 'USD',
          minimumFractionDigits: whole ? 0 : 2, maximumFractionDigits: 2
        }).format(amount);
      } catch (e) {
        return '$' + (whole ? amount.toFixed(0) : amount.toFixed(2));
      }
    }

    function textOf(scope, selector) {
      var el = scope && scope.querySelector(selector);
      return el ? el.textContent.trim() : '';
    }

    function sectionOf(el) {
      return el.closest('.shopify-section') || document;
    }

    // Read the current choices from the Pizza Night picker and Deliver every blocks
    function update(summary) {
      var section = sectionOf(summary);
      var picker = section.querySelector('.pg-picker') || document.querySelector('.pg-picker');
      if (!picker) return;
      var currency = summary.getAttribute('data-currency');

      // Oven line
      var ovenInput = picker.querySelector('[data-pg-oven-input]:checked');
      var ovenLine = summary.querySelector('[data-line="oven"]');
      if (ovenInput) {
        var ovenLabel = ovenInput.closest('[data-pg-type]');
        var colour = textOf(picker, '[data-pg-colour-name]');
        setText(summary.querySelector('[data-oven-label]'), ovenInput.value + (colour ? ' · ' + colour : ''));
        setText(summary.querySelector('[data-oven-price]'), textOf(ovenLabel, '[data-pg-type-price]'));
        setText(summary.querySelector('[data-oven-usual]'), textOf(ovenLabel, '[data-pg-type-usual]'));
      }
      setHidden(ovenLine, !ovenInput);

      // Pizza pack line
      var packInput = picker.querySelector('.pg-packs input:checked');
      var pizzaPrice = Number(picker.getAttribute('data-pg-pizza-price'));
      setText(
        summary.querySelector('[data-pack-label]'),
        (packInput ? packInput.value : '') + (summary.getAttribute('data-pack-suffix') || '')
      );
      setText(summary.querySelector('[data-pack-price]'), pizzaPrice ? money(pizzaPrice, currency) : '');

      // Today's total = the price shown on the selected plan card
      var total = ovenInput
        ? textOf(picker, '[data-pg-oven-price]')
        : textOf((picker.querySelector('.pg-plan--simple input:checked') || picker).closest('.pg-plan') || picker, '.pg-plan__price strong');
      setText(summary.querySelector('[data-total]'), total);

      // Banner
      var banner = summary.getAttribute(ovenInput ? 'data-banner-oven' : 'data-banner-pizza') || '';
      var bannerEl = summary.querySelector('[data-banner]');
      setText(bannerEl, banner);
      setHidden(bannerEl, !banner);

      // Renewal line: [price] and [frequency]
      var deliverTitle = '';
      var deliverInput = section.querySelector('.pg-deliver__input:checked') || document.querySelector('.pg-deliver__input:checked');
      if (deliverInput) deliverTitle = textOf(deliverInput.closest('.pg-deliver__card'), '.pg-deliver__title');
      var frequency = (deliverTitle || summary.getAttribute('data-default-frequency') || '').toLowerCase();
      var renew = (summary.getAttribute('data-renew') || '')
        .split('[price]').join(pizzaPrice ? money(pizzaPrice, currency) : '')
        .split('[frequency]').join(frequency);
      setText(summary.querySelector('[data-renew-line]'), renew);
    }

    var desktopQuery = window.matchMedia('(min-width: 750px)');

    // Desktop: just below the product images. Mobile: back where the block was added.
    function place(summary) {
      var section = sectionOf(summary);
      var id = summary.getAttribute('data-block-id');

      // The theme may re-draw the details column: keep a single copy
      var copies = section.querySelectorAll('[data-pg-summary][data-block-id="' + id + '"]');
      if (copies.length > 1 && copies[0] !== summary) {
        summary.remove();
        return;
      }

      var media = section.querySelector('.product-information__media');
      var anchor = section.querySelector('[data-pg-summary-anchor][data-block-id="' + id + '"]');
      var toImages = desktopQuery.matches && summary.getAttribute('data-placement') === 'below_images' && media;

      if (toImages) {
        if (summary.parentElement !== media || media.lastElementChild !== summary) media.appendChild(summary);
      } else if (anchor && anchor.nextElementSibling !== summary) {
        anchor.insertAdjacentElement('afterend', summary);
      }
    }

    function run() {
      document.querySelectorAll('[data-pg-summary]').forEach(function (summary) {
        place(summary);
        if (summary.isConnected) update(summary);
      });
    }

    var queued = false;
    function schedule() {
      if (queued) return;
      queued = true;
      requestAnimationFrame(function () {
        queued = false;
        run();
      });
    }

    function start() {
      run();
      document.addEventListener('change', schedule);
      if (desktopQuery.addEventListener) desktopQuery.addEventListener('change', schedule);
      else if (desktopQuery.addListener) desktopQuery.addListener(schedule);
      document.addEventListener('click', schedule);
      new MutationObserver(schedule).observe(document.body, {
        childList: true, subtree: true, characterData: true, attributes: true, attributeFilter: ['hidden', 'checked']
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', start);
    } else {
      start();
    }
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["pizza-night-picker"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.__pgNightPicker) return;
    window.__pgNightPicker = true;

    var state = {}; // blockId -> { colour: 'PG Pink' }

    function readData(root) {
      var raw = root.getAttribute('data-pg-addon');
      if (root.__pgData && root.__pgRaw === raw) return root.__pgData;
      root.__pgRaw = raw;
      try {
        root.__pgData = JSON.parse(raw);
      } catch (e) {
        root.__pgData = null;
      }
      return root.__pgData;
    }

    function money(cents, currency) {
      var amount = cents / 100;
      var whole = Math.round(amount * 100) % 100 === 0;
      try {
        return new Intl.NumberFormat(document.documentElement.lang || 'en-US', {
          style: 'currency',
          currency: currency || 'USD',
          minimumFractionDigits: whole ? 0 : 2,
          maximumFractionDigits: 2
        }).format(amount);
      } catch (e) {
        return '$' + (whole ? amount.toFixed(0) : amount.toFixed(2));
      }
    }

    // 'kit' falls back to the grill product if no Oven Kit product is set
    function productFor(d, type) {
      if (type === 'kit') return d.kit || d.grill;
      return d.grill || d.kit;
    }

    function findVariant(d, type, colour) {
      var p = productFor(d, type);
      if (!p || !p.variants.length) return null;
      var vs = p.variants;
      return (
        vs.find(function (v) { return v.colour === colour && v.available; }) ||
        vs.find(function (v) { return v.colour === colour; }) ||
        vs.find(function (v) { return v.available; }) ||
        vs[0]
      );
    }

    function getState(root, d) {
      var id = root.dataset.blockId;
      if (!state[id]) state[id] = { colour: d.defaultColour };
      return state[id];
    }

    function checkedOvenInput(root) {
      return root.querySelector('[data-pg-oven-input]:checked');
    }

    function currentType(root) {
      var input = checkedOvenInput(root);
      var label = input && input.closest('[data-pg-type]');
      return label ? label.dataset.pgType : 'grill';
    }

    function setText(el, text) {
      if (el && el.textContent !== text) el.textContent = text;
    }

    function escapeHtml(str) {
      return String(str).replace(/[&<>"']/g, function (c) {
        return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
      });
    }

    function coloursOf(product) {
      var seen = {};
      var list = [];
      (product ? product.variants : []).forEach(function (v) {
        if (!v.colour || seen[v.colour]) return;
        seen[v.colour] = true;
        list.push(v);
      });
      return list;
    }

    // A dot colour from the colour's name, when Shopify has no swatch colour for it
    function nameColour(name) {
      var n = String(name || '').toLowerCase();
      if (n.indexOf('pink') !== -1) return '#F2C4CB';
      if (n.indexOf('vanilla') !== -1 || n.indexOf('cream') !== -1) return '#F3EAD8';
      if (n.indexOf('pistachio') !== -1 || n.indexOf('green') !== -1) return '#C9D8B6';
      if (n.indexOf('black') !== -1) return '#1F1E1D';
      return '';
    }

    // Draw the colour buttons for the product of the chosen oven option
    // (Pizza Girl Grill product or Oven Kit product)
    function ensureSwatches(root, d, type) {
      var box = root.querySelector('.pg-swatches');
      if (!box) return;
      var forType = (type === 'kit' && d.kit) || !d.grill ? 'kit' : 'grill';
      if (box.getAttribute('data-pg-for') === forType && box.querySelector('[data-pg-colour]')) return;
      var html = '';
      coloursOf(productFor(d, forType)).forEach(function (v) {
        var named = nameColour(v.colour);
        var dot = v.swatch
          ? ' style="background-color:' + escapeHtml(v.swatch) + '"'
          : named
            ? ' style="background-color:' + named + '"'
            : (v.image ? ' style="background-image:url(' + escapeHtml(v.image) + ')"' : '');
        html +=
          '<button type="button" class="pg-swatch' + (v.available ? '' : ' is-unavailable') + '" data-pg-colour' +
          ' data-value="' + escapeHtml(v.colour) + '" aria-pressed="false">' +
          '<span class="pg-swatch__dot"' + dot + '></span>' +
          '<span class="pg-swatch__name">' + escapeHtml(v.colour) + '</span></button>';
      });
      box.innerHTML = html;
      box.setAttribute('data-pg-for', forType);
    }

    function sync(root) {
      var d = readData(root);
      if (!d || !(d.grill || d.kit)) return;
      var s = getState(root, d);
      var type = currentType(root);
      ensureSwatches(root, d, type);

      // Keep the same colour when switching Grill <-> Kit: by name, else same position
      var colours = coloursOf(productFor(d, type)).map(function (x) { return x.colour; });
      if (colours.indexOf(s.colour) === -1) {
        s.colour = colours[s.index || 0] || colours[0];
      }
      s.index = Math.max(0, colours.indexOf(s.colour));

      var v = findVariant(d, type, s.colour);
      if (!v) return;
      s.colour = v.colour;

      var oven = !!checkedOvenInput(root);
      var step = root.querySelector('[data-pg-colour-step]');
      if (step && step.hidden === oven) step.hidden = !oven;

      var product = productFor(d, type);
      root.querySelectorAll('[data-pg-colour]').forEach(function (btn) {
        var value = btn.getAttribute('data-value');
        var on = value === s.colour;
        var available = product.variants.some(function (x) { return x.colour === value && x.available; });
        btn.classList.toggle('is-selected', on);
        if (btn.getAttribute('aria-pressed') !== String(on)) btn.setAttribute('aria-pressed', String(on));
        btn.disabled = !available && !on;
        btn.classList.toggle('is-unavailable', !available);
      });
      setText(root.querySelector('[data-pg-colour-name]'), s.colour);

      if (d.mode === 'separate') {
        var card = root.querySelector('[data-pg-oven-card]');
        if (card) {
          var base = Number(card.dataset.basePrice) || 0;
          var baseCompare = Number(card.dataset.baseCompare) || base;
          var usual = Math.max(v.price, v.compare || 0);
          var price = base + v.price - d.discount;
          var compare = baseCompare + usual;
          setText(card.querySelector('[data-pg-oven-price]'), money(price, d.currency));
          var cmpEl = card.querySelector('[data-pg-oven-compare]');
          if (cmpEl) {
            setText(cmpEl, money(compare, d.currency));
            if (cmpEl.hidden !== !(compare > price)) cmpEl.hidden = !(compare > price);
          }
        }
        root.querySelectorAll('[data-pg-type]').forEach(function (label) {
          var tv = findVariant(d, label.dataset.pgType, s.colour);
          if (!tv) return;
          setText(label.querySelector('[data-pg-type-price]'), money(tv.price - d.discount, d.currency));
          setText(label.querySelector('[data-pg-type-usual]'), money(Math.max(tv.price, tv.compare || 0), d.currency));
        });
      }
    }

    function syncAll() {
      document.querySelectorAll('[data-pg-picker]').forEach(sync);
    }

    function showError(root, message) {
      var el = root.querySelector('[data-pg-error]');
      if (!el) return;
      el.textContent = message || '';
      el.hidden = !message;
    }

    // Colour swatches: keep the change away from the theme's variant picker.
    // Listen on window (capture) so this runs before the theme's own listeners.
    window.addEventListener(
      'change',
      function (e) {
        var t = e.target;
        if (!(t instanceof HTMLElement)) return;
        var root = t.closest('[data-pg-picker]');
        if (!root) return;

        if (t.matches('[data-pg-plan-input]')) {
          showError(root, '');
          requestAnimationFrame(function () { sync(root); });
        }
      },
      true
    );

    // Colour buttons: plain buttons, so the theme's variant picker never sees them
    document.addEventListener('click', function (e) {
      var btn = e.target instanceof Element ? e.target.closest('[data-pg-colour]') : null;
      if (!btn) return;
      e.preventDefault();
      var root = btn.closest('[data-pg-picker]');
      var d = root && readData(root);
      if (!d || btn.disabled) return;
      getState(root, d).colour = btn.getAttribute('data-value');
      showError(root, '');
      sync(root);
    });

    // Clicking the top of the oven card picks its first choice (if none is picked yet)
    document.addEventListener('click', function (e) {
      var head = e.target instanceof Element ? e.target.closest('[data-pg-oven-head]') : null;
      if (!head) return;
      var card = head.closest('[data-pg-oven-card]');
      if (!card || card.querySelector('[data-pg-oven-input]:checked')) return;
      var first = card.querySelector('[data-pg-oven-input]:not([aria-disabled="true"])') ||
        card.querySelector('[data-pg-oven-input]');
      if (first) first.click();
    });

    function rootForVariant(variantId) {
      var id = Number(variantId);
      return Array.prototype.find.call(document.querySelectorAll('[data-pg-picker]'), function (root) {
        var d = readData(root);
        return d && d.variantIds.indexOf(id) !== -1;
      });
    }

    function setHiddenProp(form, name, value) {
      var input = form.querySelector('input[data-pg-prop][name="' + name + '"]');
      if (value == null) {
        if (input) input.remove();
        return;
      }
      if (!input) {
        input = document.createElement('input');
        input.type = 'hidden';
        input.name = name;
        input.setAttribute('data-pg-prop', '');
        form.appendChild(input);
      }
      input.value = value;
    }

    function log() {
      if (window.console && console.info) {
        console.info.apply(console, ['[Pizza Night]'].concat([].slice.call(arguments)));
      }
    }

    // Save the colour on the subscription, or add the grill / kit as its own item.
    // Listen on window (capture) so this runs BEFORE Horizon's add to cart.
    window.addEventListener(
      'submit',
      function (e) {
        var form = e.target;
        if (!(form instanceof HTMLFormElement)) return;
        if ((form.getAttribute('action') || '').indexOf('/cart/add') === -1) return;
        var idInput = form.querySelector('[name="id"]');
        if (!idInput) return;
        var root = rootForVariant(idInput.value);
        if (!root) { log('no picker found for variant', idInput.value); return; }
        var d = readData(root);
        if (!d || !(d.grill || d.kit)) { log('no oven product can be read: check both are Active and on the Online Store'); return; }
        var s = getState(root, d);
        var propName = 'properties[' + d.propName + ']';

        var bundlePropName = 'properties[_bundle_id]';

        if (!checkedOvenInput(root)) {
          setHiddenProp(form, propName, null);
          setHiddenProp(form, bundlePropName, null);
          log('pizza-only plan: nothing extra to add');
          return;
        }

        var type = currentType(root);
        var v = findVariant(d, type, s.colour);

        if (d.mode === 'property') {
          setHiddenProp(form, bundlePropName, null);
          setHiddenProp(form, propName, s.colour);
          log('mode is "Price is in the variant": saved colour', s.colour, '(no grill item added)');
          return;
        }

        if (!v || !v.available) {
          e.preventDefault();
          e.stopImmediatePropagation();
          showError(root, d.soldOut);
          document.dispatchEvent(new CustomEvent('pg:addon-error'));
          log('grill variant sold out or missing', v);
          return;
        }
        showError(root, '');

        // Same hidden ID on the grill and the subscription, so the cart can remove them together
        var bundleId = 'pn-' + Date.now().toString(36) + Math.random().toString(36).slice(2, 6);
        setHiddenProp(form, bundlePropName, bundleId);

        // Don't stop the theme: its own add to cart request will carry the grill too (one request)
        pendingExtra = {
          mainId: String(idInput.value),
          expires: Date.now() + 15000,
          item: { id: v.id, quantity: 1, properties: { _Bundle: d.productTitle, _bundle_id: bundleId } }
        };
        log('grill', v.id, v.colour, 'will be added together with the subscription');
      },
      true
    );

    // ── One request for both items ─────────────────────────────────────
    // Horizon sends the add to cart as FormData. When a grill / kit is waiting, turn that
    // request into a single JSON request with both items (subscription + oven).
    var pendingExtra = null;

    function takeExtra(mainId) {
      if (!pendingExtra) return null;
      if (Date.now() > pendingExtra.expires || pendingExtra.mainId !== String(mainId)) {
        pendingExtra = null;
        return null;
      }
      var item = pendingExtra.item;
      pendingExtra = null;
      return item;
    }

    function formDataToItems(fd, extra) {
      var main = { id: Number(fd.get('id')), quantity: Number(fd.get('quantity')) || 1 };
      if (fd.get('selling_plan')) main.selling_plan = Number(fd.get('selling_plan'));
      var props = {};
      fd.forEach(function (value, key) {
        var m = /^properties\[(.+)\]$/.exec(key);
        if (m && typeof value === 'string') props[m[1]] = value;
      });
      if (Object.keys(props).length) main.properties = props;

      var body = { items: [main, extra] };
      var sections = [];
      fd.getAll('sections').forEach(function (value) {
        String(value).split(',').forEach(function (id) {
          id = id.trim();
          if (id && sections.indexOf(id) === -1) sections.push(id);
        });
      });
      if (sections.length) body.sections = sections.join(',');
      if (fd.get('sections_url')) body.sections_url = fd.get('sections_url');
      return body;
    }

    var nativeFetch = window.fetch;
    if (nativeFetch && !nativeFetch.__pgOven) {
      var ovenFetch = function (resource, options) {
        try {
          var url = typeof resource === 'string' ? resource : (resource && resource.url) || '';
          var body = options && options.body;
          if (url.indexOf('/cart/add') !== -1 && body instanceof FormData && body.has('id')) {
            var extra = takeExtra(body.get('id'));
            if (extra) {
              var headers = new Headers((options && options.headers) || {});
              headers.set('Content-Type', 'application/json');
              if (!headers.has('X-Requested-With')) headers.set('X-Requested-With', 'XMLHttpRequest');
              var json = formDataToItems(body, extra);
              options = Object.assign({}, options, { body: JSON.stringify(json), headers: headers });
              log('adding subscription + oven in one request', json.items.map(function (i) { return i.id; }).join(' + '));
            }
          }
        } catch (err) {
          log('could not combine the request', err);
        }
        return nativeFetch.call(this, resource, options);
      };
      ovenFetch.__pgOven = true;
      window.fetch = ovenFetch;
    }

    // The theme re-renders the picker on every variant change: re-apply our state
    var queued = false;
    function schedule() {
      if (queued) return;
      queued = true;
      requestAnimationFrame(function () {
        queued = false;
        syncAll();
      });
    }

    function start() {
      syncAll();
      new MutationObserver(schedule).observe(document.body, { childList: true, subtree: true });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', start);
    } else {
      start();
    }
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["pizza-night-title"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.__pgTitle) return;
    window.__pgTitle = true;

    function readState(block) {
      var section = block.closest('.shopify-section') || document;
      var picker = section.querySelector('.pg-picker') || document.querySelector('.pg-picker');
      if (!picker) return null;

      var oven = picker.querySelector('[data-pg-oven-input]:checked');
      var totalEl = oven
        ? picker.querySelector('[data-pg-oven-price]')
        : (function () {
            var plan = picker.querySelector('.pg-plan--simple input:checked');
            return plan && plan.closest('.pg-plan').querySelector('.pg-plan__price strong');
          })();
      var colourEl = picker.querySelector('[data-pg-colour-name]');
      var kitValue = block.getAttribute('data-kit-value');

      var state = 'pizza';
      if (oven) state = kitValue && oven.value === kitValue && block.getAttribute('data-title-kit') ? 'kit' : 'oven';

      return {
        state: state,
        total: totalEl ? totalEl.textContent.trim() : '',
        oven: oven ? oven.value : '',
        colour: colourEl ? colourEl.textContent.trim() : ''
      };
    }

    function fill(text, s) {
      return (text || '')
        .split('[total]').join(s.total)
        .split('[oven]').join(s.oven)
        .split('[colour]').join(s.colour);
    }

    function update(block) {
      var s = readState(block);
      if (!s) return;

      var heading = block.querySelector('[data-pg-title-heading]');
      var title = fill(block.getAttribute('data-title-' + s.state), s).trim();
      if (heading && title && heading.textContent !== title) heading.textContent = title;

      // The line under the title is rich text: switch its HTML, kit falls back to the oven line
      var sub = block.querySelector('[data-pg-title-sub]');
      var html = block.getAttribute('data-sub-' + s.state) || (s.state === 'kit' ? block.getAttribute('data-sub-oven') : '') || '';
      html = fill(html, s);
      if (sub && sub.__pgHtml !== html) {
        sub.__pgHtml = html;
        sub.innerHTML = html;
        sub.hidden = !html;
      }
    }

    function updateAll() {
      document.querySelectorAll('[data-pg-title]').forEach(update);
    }

    var queued = false;
    function schedule() {
      if (queued) return;
      queued = true;
      requestAnimationFrame(function () {
        queued = false;
        updateAll();
      });
    }

    function start() {
      updateAll();
      document.addEventListener('change', schedule);
      document.addEventListener('click', schedule);
      new MutationObserver(schedule).observe(document.body, { childList: true, subtree: true, characterData: true });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', start);
    } else {
      start();
    }
  })();
  } catch(e) { console.error(e); }
})();

})();
